import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  container: {
    marginTop: 20,
    maxHeight: 440,
    borderRadius: 6,
    border: '1px solid #ccc',
  },
  table: {
    minWidth: 650,
  },
});

function createData(no, set, nameEn, nameTh, meaning, from) {
  return {
    no, set, nameEn, nameTh, meaning, from,
  };
}

const rows = [
  createData(1, 1, 'DAMREY', 'ด็อมเร็ย', 'ช้าง', 'ราชอาณาจักรกัมพูชา'),
  createData(2, 1, 'HAIKUI', 'ไห่ขุย', 'ชื่อดอกไม้ทะเลชนิดหนึ่ง', 'สาธารณรัฐประชาชนจีน'),
  createData(3, 1, 'KIROGI', 'คีโรกี', 'ห่านป่า', 'สาธารณรัฐประชาธิปไตยประชาชนเกาหลี'),
  createData(4, 1, 'YUN-YEUNG', 'ยุนยาง', 'เป็ดแมนดาริน', 'เขตบริหารพิเศษฮ่องกง'),
  createData(5, 1, 'KOINU', 'โคอินุ', 'ลูกสุนัข', 'ญี่ปุ่น'),
  createData(6, 1, 'BOLAVEN', 'บอละเวน', 'ที่ราบสูงทางตอนใต้ของประเทศสาธารณรัฐประชาธิปไตยประชาชนลาว', 'สาธารณรัฐประชาธิปไตยประชาชนลาว'),
  createData(7, 1, 'SANBA', 'ซันปา', 'ชื่อสถานที่ในเขตบริหารพิเศษมาเก๊า', 'เขตบริหารพิเศษมาเก๊า'),
  createData(8, 1, 'JELAWAT', 'เจอลาวัต', 'ชื่อปลาน้ำจืดชนิดหนึ่ง', 'มาเลเซีย'),
  createData(9, 1, 'EWINIAR', 'เอวิเนียร์', 'ชื่อเทพเจ้าแห่งพ[ภาษาพื้นเมืองของเกาะชุก (Chuuk)]', 'สาธารณรัฐสหพันธ์ไมโครนีเซีย'),
  createData(10, 1, 'MALIKSI', 'มาลิกซี', 'เร็ว', 'ฟิลิปปินส์'),
  createData(11, 1, 'GAEMI', 'แคมี', 'มด', 'สาธารณรัฐเกาหลี (เกาหลีใต้)'),
  createData(12, 1, 'PRAPIROON', 'พระพิรุณ', 'ชื่อเทพเจ้าแห่งฝน', 'ไทย'),
  createData(13, 1, 'MARIA', 'มาเรีย', 'ชื่อผู้หญิง [ภาษาของชนเผ่าชามอร์โรในมาเรียนา (Mariana)]', 'สหรัฐอเมริกา'),
  createData(14, 1, 'SON-TINH', 'เซินติญ', 'ชื่อเทพเจ้าแห่งขุนเขาในเรื่องปรัมปราของสาธารณรัฐสังคมนิยมเวียดนาม', 'สาธารณรัฐสังคมนิยมเวียดนาม'),
  createData(15, 1, 'AMPIL', 'อ็อมปึล', 'มะขาม', 'ราชอาณาจักรกัมพูชา'),
  createData(16, 1, 'WUKONG', 'อู๋คง', 'พญาวานรที่มีชื่อเสียงในเรื่องทางพระพุทธศาสนาของสาธารณรัฐประชาชนจีน', 'สาธารณรัฐประชาชนจีน'),
  createData(17, 1, 'JONGDARI', 'ชงดารี', 'นกจาบฝน', 'สาธารณรัฐประชาธิปไตยประชาชนเกาหลี'),
  createData(18, 1, 'SHANSHAN', 'ชานชาน', 'ชื่อของเด็กหญิง', 'เขตบริหารพิเศษฮ่องกง'),
  createData(19, 1, 'YAGI', 'ยางิ', 'ราศีมังกร, แพะ', 'ญี่ปุ่น'),
  createData(20, 1, 'LEEPI', 'หลี่ผี', 'น้ำตกที่สวยที่สุดทางตอนใต้ของประเทศสาธารณรัฐประชาธิปไตยประชาชนลาว', 'สาธารณรัฐประชาธิปไตยประชาชนลาว'),
  createData(21, 1, 'BEBINCA', 'เบบินคา', 'ชื่อขนมพุดดิงของเขตบริหารพิเศษมาเก๊า', 'เขตบริหารพิเศษมาเก๊า'),
  createData(22, 1, 'PULASAN', 'ปูลาซัน', 'ผลไม้ชนิดหนึ่งคล้ายเงาะ', 'มาเลเซีย'),
  createData(23, 1, 'SOULIK', 'ซูลิก', 'ต้าแหน่งหัวหน้าเผ่าโบราณของเกาะโปนเป (Pohnpei)', 'สาธารณรัฐสหพันธ์ไมโครนีเซีย'),
  createData(24, 1, 'CIMARON', 'ซีมารอน', 'วัวป่าของฟิลิปปินส์', 'ฟิลิปปินส์'),
  createData(25, 1, 'JEBI', 'เชบี', 'นกนางแอ่น', 'สาธารณรัฐเกาหลี (เกาหลีใต้)'),
  createData(26, 1, 'KRATHON', 'กระท้อน', 'ชื่อผลไม้ชนิดหนึ่ง', 'ไทย'),
  createData(27, 1, 'BARIJAT', 'บารีจัต', 'ชายฝั่งที่มีคลื่นลม [ภาษาพื้นเมืองของหมู่เกาะมาร์แซล (Marshall)]', 'สหรัฐอเมริกา'),
  createData(28, 2, 'TRAMI', 'จ่ามี', 'ชื่อดอกไม้ชนิดหนึ่งในสกุลดอกกุหลาบ', 'สาธารณรัฐสังคมนิยมเวียดนาม'),
  createData(29, 2, 'KONG-REY', 'กองเร็ย', 'ชื่อสาวงามในต้านานเขมร, ชื่อภูเขา', 'ราชอาณาจักรกัมพูชา'),
  createData(30, 2, 'YINXING', 'หยินซิ่ง', 'ต้นไม้ท้องถิ่นในประเทศจีน', 'สาธารณรัฐประชาชนจีน'),
  createData(31, 2, 'TORAJI', 'โทราจี', 'ชื่อต้นไม้มีดอกสวยงามพบในเกาหลี รากใช้ทำอาหารและยา', 'สาธารณรัฐประชาธิปไตยประชาชนเกาหลี'),
  createData(32, 2, 'MAN-YI', 'หม่านหยี่', 'ชื่อช่องแคบ ปัจจุบันเป็นอ่างเก็บน้ำ', 'เขตบริหารพิเศษฮ่องกง'),
  createData(33, 2, 'USAGI', 'อูซางิ', 'กระต่าย', 'ญี่ปุ่น'),
  createData(34, 2, 'PABUK', 'ปาบึก', 'ชื่อปลาน้ำจืดขนาดใหญ่ (ปลาบึก) อยู่ในแม่น้ำโขง', 'สาธารณรัฐประชาธิปไตยประชาชนลาว'),
  createData(35, 2, 'WUTIP', 'หวู่ติบ', 'ผีเสื้อ', 'เขตบริหารพิเศษมาเก๊า'),
  createData(36, 2, 'SEPAT', 'เซอปัต', 'ปลาชนิดหนึ่ง (ปลาตีน)', 'มาเลเซีย'),
  createData(37, 2, 'MUN', 'มูน', 'เดือนมิถุนายน [ภาษาพื้นเมืองของหมู่เกาะยาป (Yap)]', 'สาธารณรัฐสหพันธ์ไมโครนีเซีย'),
  createData(38, 2, 'DANAS', 'ดานัส', 'ประสบการณ์และความรู้สึก', 'ฟิลิปปินส์'),
  createData(39, 2, 'NARI', 'นารี', 'ดอกลิลี', 'สาธารณรัฐเกาหลี (เกาหลีใต้)'),
  createData(40, 2, 'WIPHA', 'วิภา', 'ชื่อของผู้หญิง', 'ไทย'),
  createData(41, 2, 'FRANCISCO', 'ฟรานซิสโก', 'ชื่อของผู้ช[ภายษาของชนเผ่าชามอร์โรในหมู่เกาะมาเรียนา (Mariana)]', 'สหรัฐอเมริกา'),
  createData(42, 2, 'CO-MAY', 'ก๋อมัย', 'หญ้าเจ้าชู้', 'สาธารณรัฐสังคมนิยมเวียดนาม'),
  createData(43, 2, 'KROSA', 'กรอซา', 'นกกระสา, นกกระเรียน', 'ราชอาณาจักรกัมพูชา'),
  createData(44, 2, 'BAILU', 'ไป๋ลู่', 'กวางขาว', 'สาธารณรัฐประชาชนจีน'),
  createData(45, 2, 'PODUL', 'โพดุล', 'ต้นหลิว', 'สาธารณรัฐประชาธิปไตยประชาชนเกาหลี'),
  createData(46, 2, 'LINGLING', 'เหล่งเหล่ง', 'ชื่อของเด็กหญิง', 'เขตบริหารพิเศษฮ่องกง'),
  createData(47, 2, 'KAJIKI', 'คาจิกิ', 'ชื่อปลาทะเลที่มีสีสวยงาม', 'ญี่ปุ่น'),
  createData(48, 2, 'NONGFA', 'หนองฟ้า', 'ชื่อทะเลสาบ', 'สาธารณรัฐประชาธิปไตยประชาชนลาว'),
  createData(49, 2, 'PEIPAH', 'เผ่ย์ผ่า', 'ปลาที่เลี้ยงไว้ดูเล่นชนิดหนึ่งในมาเก๊า', 'เขตบริหารพิเศษมาเก๊า'),
  createData(50, 2, 'TAPAH', 'ตาปะฮ์', 'ชื่อปลาน้ำจืดชนิดหนึ่ง', 'มาเลเซีย'),
  createData(51, 2, 'MITAG', 'มิแทก', 'ชื่อของผู้หญิง [ภาษาพื้นเมืองของเกาะแยป (Yap)]', 'สาธารณรัฐสหพันธ์ไมโครนีเซีย'),
  createData(52, 2, 'RAGASA', 'รากาซา', 'กระโชก', 'ฟิลิปปินส์'),
  createData(53, 2, 'NEOGURI', 'นอกูรี', 'ชื่อสุนัขพันธุ์หนึ่งในสาธารณรัฐเกาหลีลักษณะคล้ายตัวแร็กคูน', 'สาธารณรัฐเกาหลี (เกาหลีใต้)'),
  createData(54, 2, 'BUALOI', 'บัวลอย', 'ขนมชนิดหนึ่ง', 'ไทย'),
  createData(55, 2, 'MATMO', 'แมตโม', 'ฝนที่ตกหนัก', 'สหรัฐอเมริกา'),
  createData(56, 2, 'HALONG', 'หะลอง', 'ชื่ออ่าวที่สวยงามแห่งหนึ่งของสาธารณรัฐสังคมนิยมเวียดนาม', 'สาธารณรัฐสังคมนิยมเวียดนาม'),
  createData(57, 3, 'NAKRI', 'นากรี', 'ชื่อดอกไม้ชนิดหนึ่ง', 'ราชอาณาจักรกัมพูชา'),
  createData(58, 3, 'FENGSHEN', 'เฟิงเฉิน', 'ชื่อเทพเจ้าแห่งลม', 'สาธารณรัฐประชาชนจีน'),
  createData(59, 3, 'KALMAEGI', 'คัลแมกี', 'นกนางนวล', 'สาธารณรัฐประชาธิปไตยประชาชนเกาหลี'),
  createData(60, 3, 'FUNG-WONG', 'ฟงวอง', 'ฟีนิกซ์ (ชื่อยอดเขา)', 'เขตบริหารพิเศษฮ่องกง'),
  createData(61, 3, 'KOTO', 'โคโตะ', 'พิณโคโตะ', 'ญี่ปุ่น'),
  createData(62, 3, 'NOKAEN', 'นกแอ่น', 'ชื่อนกชนิดหนึ่ง', 'สาธารณรัฐประชาธิปไตยประชาชนลาว'),
  createData(63, 3, 'VONGFONG', 'หว่องฟ้ง', 'ตัวต่อ', 'เขตบริหารพิเศษมาเก๊า'),
  createData(64, 3, 'NURI', 'นูรี', 'ชื่อนกแก้วหัวสีน้ำเงินในภาษามลายู', 'มาเลเซีย'),
  createData(65, 3, 'SINLAKU', 'ซินลากู', 'ชื่อเทพธิดาในนิยายของเกาะคอสไร', 'สาธารณรัฐสหพันธ์ไมโครนีเซีย'),
  createData(66, 3, 'HAGUPIT', 'ฮากูปิต', 'เฆี่ยนตี', 'ฟิลิปปินส์'),
  createData(67, 3, 'JANGMI', 'ชังมี', 'กุหลาบ', 'สาธารณรัฐเกาหลี (เกาหลีใต้)'),
  createData(68, 3, 'MEKKHALA', 'เมขลา', 'ชื่อเทพธิดาประจ้าสมุทรในเทพนิยายไทย', 'ไทย'),
  createData(69, 3, 'HIGOS', 'ฮีโกส', 'ผลมะเดื่อ[ภาษาของชนเผ่าชามอร์โรในหมู่เกาะมาเรียนา (Mariana)]', 'สหรัฐอเมริกา'),
  createData(70, 3, 'BAVI', 'บาหวี่', 'ทิวเขาในภาคเหนือของสาธารณรัฐสังคมนิยมเวียดนาม', 'สาธารณรัฐสังคมนิยมเวียดนาม'),
  createData(71, 3, 'MAYSAK', 'ไมสัก', 'ชื่อต้นไม้ชนิดหนึ่ง', 'ราชอาณาจักรกัมพูชา'),
  createData(72, 3, 'HAISHEN', 'ไห่เฉิน', 'ชื่อเทพเจ้าแห่งท้องทะเล', 'สาธารณรัฐประชาชนจีน'),
  createData(73, 3, 'NOUL', 'โนอึล', 'เรืองแสง, ท้องฟ้าสีแดง', 'สาธารณรัฐประชาธิปไตยประชาชนเกาหลี'),
  createData(74, 3, 'DOLPHIN', 'ดอลฟิน', 'โลมาสีขาวซึ่งอาศัยอยู่ในเขตน่านน้ำฮ่องกงและเป็นตัวนำโชคของฮ่องกง', 'เขตบริหารพิเศษฮ่องกง'),
  createData(75, 3, 'KUJIRA', 'คูจิระ', 'กลุ่มดาวซีตัส, วาฬ', 'ญี่ปุ่น'),
  createData(76, 3, 'CHAN-HOM', 'จันหอม', 'ชื่อต้นไม้ชนิดหนึ่ง', 'สาธารณรัฐประชาธิปไตยประชาชนลาว'),
  createData(77, 3, 'LINFA', 'หลิ่นฟา', 'ดอกบัว', 'เขตบริหารพิเศษมาเก๊า'),
  createData(78, 3, 'NANGKA', 'นังกา', 'ขนุน', 'มาเลเซีย'),
  createData(79, 3, 'SAUDEL', 'โซเดล', 'ชื่อนายทหารองครักษ์ของหัวหน้าเผ่าบนโปนเป สาธารณรัฐสหพันธ์ไมโครนีเซีย', 'สาธารณรัฐสหพันธ์ไมโครนีเซีย'),
  createData(80, 3, 'MOLAVE', 'โมลาเบ', 'ชื่อไม้เนื้อแข็งชนิดหนึ่งใช้ทำเครื่องเรือน', 'ฟิลิปปินส์'),
  createData(81, 3, 'GONI', 'โคนี', 'หงส์', 'สาธารณรัฐเกาหลี(เกาหลีใต้)'),
  createData(82, 3, 'ATSANI', 'อัสนี', 'สายฟ้า', 'ไทย'),
  createData(83, 3, 'ETAU', 'เอตาว', 'เมฆฝน [ภาษาพื้นเมืองของเกาะปาเลา(Palua)]', 'สหรัฐอเมริกา'),
  createData(84, 3, 'VAMCO', 'หว่ามก๋อ', 'ชื่อแม่น้ำในสาธารณรัฐสังคมนิยมเวียดนามตอนใต้', 'สาธารณรัฐสังคมนิยมเวียดนาม'),
  createData(85, 4, 'KROVANH', 'กรอวาญ', 'ชื่อต้นไม้ชนิดหนึ่ง (กระวาน)', 'ราชอาณาจักรกัมพูชา'),
  createData(86, 4, 'DUJUAN', 'ตู้เจวียน', 'กุหลาบพันปี', 'สาธารณรัฐประชาชนจีน'),
  createData(87, 4, 'SURIGAE', 'ซูรีแค', 'ชื่อนกอินทรีชนิดหนึ่ง', 'สาธารณรัฐประชาธิปไตยประชาชนเกาหลี'),
  createData(88, 4, 'CHOI-WAN', 'ฉอยหวั่น', 'เมฆซึ่งมีสีสันสวยงาม', 'เขตบริหารพิเศษฮ่องกง'),
  createData(89, 4, 'KOGUMA', 'โคะงุมะ', 'ดาวหมีน้อย', 'ญี่ปุ่น'),
  createData(90, 4, 'CHAMPI', 'จ้าปี', 'ชื่อดอกไม้ชนิดหนึ่ง', 'สาธารณรัฐประชาธิปไตยประชาชนลาว'),
  createData(91, 4, 'IN-FA', 'ยีนฟ้า', 'ดอกไม้ไฟ', 'เขตบริหารพิเศษมาเก๊'),
  createData(92, 4, 'CEMPAKA', 'เจิมปากา', 'ดอกจำปา', 'มาเลเซีย'),
  createData(93, 4, 'NEPARTAK', 'เนพาร์ตัก', 'นักรบที่มีชื่อเสียงของชาวเกาะคอสไร', 'สาธารณรัฐสหพันธ์ไมโครนีเซีย'),
  createData(94, 4, 'LUPIT', 'ลูปิต', 'โหดร้ายทารุณ', 'ฟิลิปปินส์'),
  createData(95, 4, 'MIRINAE', 'มีรีแน', 'ทางช้างเผือก', 'สาธารณรัฐเกาหลี (เกาหลีใต้)'),
  createData(96, 4, 'NIDA', 'นิดา', 'ชื่อของผู้หญิง', 'ไทย'),
  createData(97, 4, 'OMAIS', 'โอไมส์', 'พเนจร [ภาษาพื้นเมืองของเกาะปาเลา(Palua)]', 'สหรัฐอเมริกา'),
  createData(98, 4, 'CONSON', 'โกนเซิน', 'ชื่อโบราณสถานแห่งหนึ่งในสาธารณรัฐสังคมนิยมเวียดนาม', 'สาธารณรัฐสังคมนิยมเวียดนาม'),
  createData(99, 4, 'CHANTHU', 'จันทู', 'ชื่อดอกไม้ชนิดหนึ่ง', 'ราชอาณาจักรกัมพูชา'),
  createData(100, 4, 'DIANMU', 'เตี้ยนหมู่', 'เจ้าแม่แห่งสายฟ้า', 'สาธารณรัฐประชาชนจีน'),
  createData(101, 4, 'MINDULLE', 'มินดุลเล', 'ชื่อดอกไม้ชนิดหนึ่ง', 'สาธารณรัฐประชาธิปไตยประชาชนเกาหลี'),
  createData(102, 4, 'LIONROCK', 'ไลออนร็อก', 'ชื่อยอดเขาในฮ่องกง', 'เขตบริหารพิเศษฮ่องกง'),
  createData(103, 4, 'KOMPASU', 'คมปาซุ', 'กลุ่มดาววงเวียน', 'ญี่ปุ่น'),
  createData(104, 4, 'NAMTHEUN', 'น้ำเทิน', 'ชื่อแม่น้ำซึ่งเป็นแควของแม่น้ำโขง', 'สาธารณรัฐประชาธิปไตยประชาชนลาว'),
  createData(105, 4, 'MALOU', 'หมาเหล่า', 'อะเกต, หินโมรา', 'เขตบริหารพิเศษมาเก๊า'),
  createData(106, 4, 'NYATOH', 'ญาโตะฮ์', 'ชื่อไม้เนื้อแข็งชนิดหนึ่ง', 'มาเลเซีย'),
  createData(107, 4, 'RAI', 'ราอี', 'เงินตราพื้นเมืองของเกาะแยป', 'สาธารณรัฐสหพันธ์ไมโครนีเซีย'),
  createData(108, 4, 'MALAKAS', 'มาลากัส', 'แข็งแรง, มีอำนาจ', 'ฟิลิปปินส์'),
  createData(109, 4, 'MEGI', 'เมกี', 'ชื่อปลาชนิดหนึ่ง', 'สาธารณรัฐเกาหลี (เกาหลีใต้)'),
  createData(110, 4, 'CHABA', 'ชบา', 'ชื่อดอกไม้ชนิดหนึ่ง', 'ไทย'),
  createData(111, 4, 'AERE', 'แอรี', 'พายุ [ภาษาพื้นเมืองของหมู่เกาะมาร์แชล (Marshall)]', 'สหรัฐอเมริกา'),
  createData(112, 4, 'SONGDA', 'ซงด่า', 'ชื่อแม่น้ำทางด้านตะวันตกเฉียงเหนือของสาธารณรัฐสังคมนิยมเวียดนาม', 'สาธารณรัฐสังคมนิยมเวียดนาม'),
  createData(113, 5, 'TRASES', 'ตรอแซะฮ์', 'นกหัวขวาน', 'ราชอาณาจักรกัมพูชา'),
  createData(114, 5, 'MULAN', 'มู่หลาน', 'ชื่อดอกไม้ชนิดหนึ่งในตระกูลแม็กโนเลีย', 'สาธารณรัฐประชาชนจีน'),
  createData(115, 5, 'MEARI', 'เมอารี', 'เสียงสะท้อน', 'สาธารณรัฐประชาธิปไตยประชาชนเกาหลี'),
  createData(116, 5, 'MA-ON', 'หมาอ๊อน', 'ชื่อยอดเขาในฮ่องกง มีความหมายว่า อานม้า', 'เขตบริหารพิเศษฮ่องกง'),
  createData(117, 5, 'TOKAGE', 'โทกาเงะ', 'ชื่อกลุ่มดาวลาเซอร์ตา, กิ้งก่า', 'ญี่ปุ่น'),
  createData(118, 5, 'HINNAMNOR', 'หินหนามหน่อ', 'ห่านป่า', 'สาธารณรัฐประชาธิปไตยประชาชนลาว'),
  createData(119, 5, 'MUIFA', 'หมุ่ยฟ้า', 'ดอกบ๊วย', 'เขตบริหารพิเศษมาเก๊า'),
  createData(120, 5, 'MERBOK', 'เมอร์บก', 'ชื่อนกชนิดหนึ่ง (นกเขา)', 'มาเลเซีย'),
  createData(121, 5, 'NANMADOL', 'นันมาดอล', 'โบราณสถานที่มีชื่อเสียงของเกาะโปนเป (Pohnpei) ได้รับสมญาว่า เวนิสแห่งแปซิฟิก', 'สาธารณรัฐสหพันธ์ไมโครนีเซีย'),
  createData(122, 5, 'TALAS', 'ตาลัส', 'ความคม, ความเฉียบแหลม', 'ฟิลิปปินส์'),
  createData(123, 5, 'NORU', 'โนรู', 'ชื่อกวางชนิดหนึ่ง', 'สาธารณรัฐเกาหลี (เกาหลีใต้)'),
  createData(124, 5, 'KULAP', 'กุหลาบ', 'ชื่อดอกไม้ชนิดหนึ่ง', 'ไทย'),
  createData(125, 5, 'ROKE', 'โรคี', 'ชื่อของผู้ชาย [ภาษาของชนเผ่าชามอร์โรในหมู่เกาะมาเรียนา (Mariana)]', 'สหรัฐอเมริกา'),
  createData(126, 5, 'SONCA', 'เซินกา', 'ชื่อนกชนิดหนึ่งมีเสียงไพเราะ', 'สาธารณรัฐสังคมนิยมเวียดนาม'),
  createData(127, 5, 'NESAT', 'เนสาท', 'การประมง', 'ราชอาณาจักรกัมพูชา'),
  createData(128, 5, 'HAITANG', 'ไห่ถาง', 'ชื่อผลไม้ชนิดหนึ่งของสาธารณรัฐประชาชนจีน ผลคล้ายแอ็ปเปิ้ลขนาดเล็ก', 'สาธารณรัฐประชาชนจีน'),
  createData(129, 5, 'NALGAE', 'นัลแก', 'ปีก', 'สาธารณรัฐประชาธิปไตยประชาชนเกาหลี'),
  createData(130, 5, 'BANYAN', 'บันยัน', 'ชื่อต้นไม้ชนิดหนึ่ง (ไทร)', 'เขตบริหารพิเศษฮ่องกง'),
  createData(131, 5, 'YAMANEKO', 'ยามาเนโกะ', 'แมวป่า', 'ญี่ปุ่น'),
  createData(132, 5, 'PAKHAR', 'ปาข่า', 'ชื่อปลาน้ำจืดชนิดหนึ่งอยู่ในแม่น้ำโขงตอนล่าง', 'สาธารณรัฐประชาธิปไตยประชาชนลาว'),
  createData(133, 5, 'SANVU', 'ซ้านหวู่', 'ปะการัง', 'เขตบริหารพิเศษมาเก๊า'),
  createData(134, 5, 'MAWAR', 'มาวาร์', 'กุหลาบ', 'มาเลเซีย'),
  createData(135, 5, 'GUCHOL', 'กูโชล', 'ขมิ้นชัน [ภาษาพื้นเมืองของเกาะแยป(Yap)]', 'สาธารณรัฐสหพันธ์ไมโครนีเซีย'),
  createData(136, 5, 'TALIM', 'ตาลิม', 'คม, คมมีด', 'ฟิลิปปินส์'),
  createData(137, 5, 'DOKSURI', 'ทกซูรี', 'นกอินทรี', 'สาธารณรัฐเกาหลี (เกาหลีใต้)'),
  createData(138, 5, 'KHANUN', 'ขนุน', 'ชื่อผลไม้ชนิดหนึ่งของไทย', 'ไทย'),
  createData(139, 5, 'LAN', 'แลง', 'พายุ [ภาษาพื้นเมืองของหมู่เกาะมาร์แชล (Marshall)]', 'สหรัฐอเมริกา'),
  createData(140, 5, 'SAOLA', 'เซาลา', 'ชื่อสัตว์ชนิดหนึ่ง ตระกูลวัวสาธารณรัฐพบในสังคมนิยมเวียดนาม', 'สาธารณรัฐสังคมนิยมเวียดนาม'),
];

const rowsEn = [
  createData(1, 1, 'DAMREY', 'DAMREY', 'Elephant', 'Cambodia'),
  createData(2, 1, 'HAIKUI', 'HAIKUI', 'A kind of sea anemone', 'China'),
  createData(3, 1, 'KIROGI', 'KIROGI', 'Wild goose', 'DPR Korea'),
  createData(4, 1, 'YUN-YEUNG', 'YUN-YEUNG', 'A species of duck (Aix galericulata)', 'Hong Kong, China'),
  createData(5, 1, 'KOINU', 'KOINU', 'Puppy', 'Japan'),
  createData(6, 1, 'BOLAVEN', 'BOLAVEN', 'Plateau in the southern part of LAO', 'Lao PDR'),
  createData(7, 1, 'SANBA', 'SANBA', 'Placename in Macao, China', 'Macao, China'),
  createData(8, 1, 'JELAWAT', 'JELAWAT', 'A freshwater fish ', 'Malaysia'),
  createData(9, 1, 'EWINIAR', 'EWINIAR', 'Chuuk traditional storm god', 'Micronesia'),
  createData(10, 1, 'MALIKSI', 'MALIKSI', 'Fast', 'Philippines'),
  createData(11, 1, 'GAEMI', 'GAEMI', 'Ant', 'RO Korea'),
  createData(12, 1, 'PRAPIROON', 'PRAPIROON', 'God of rain', 'Thailand'),
  createData(13, 1, 'MARIA', 'MARIA', "Chamorro woman's name", 'U.S.A.'),
  createData(14, 1, 'SON-TINH', 'SON-TINH', 'God of mountain in Vietnamese myth', 'Viet Nam'),
  createData(15, 1, 'AMPIL', 'AMPIL', 'Tamarind', 'Cambodia'),
  createData(16, 1, 'WUKONG', 'WUKONG', 'Famous hero in Chinese story (The King of the monkeys)', 'China'),
  createData(17, 1, 'JONGDARI', 'JONGDARI', 'Skylark', 'DPR Korea'),
  createData(18, 1, 'SHANSHAN', 'SHANSHAN', 'Name of young girls', 'Hong Kong, China'),
  createData(19, 1, 'YAGI', 'YAGI', 'Capricornm, goat', 'Japan'),
  createData(20, 1, 'LEEPI', 'LEEPI', 'The most beautiful waterfall in southern Lao', 'Lao PDR'),
  createData(21, 1, 'BEBINCA', 'BEBINCA', 'Macanese milk pudding, China', 'Macao, China'),
  createData(22, 1, 'PULASAN', 'PULASAN', 'A kind of fruit like rambutan', 'Malaysia'),
  createData(23, 1, 'SOULIK', 'SOULIK', "Traditional Pohnpei chief's title", 'Micronesia'),
  createData(24, 1, 'CIMARON', 'CIMARON', 'Philippine wild ox', 'Philippines'),
  createData(25, 1, 'JEBI', 'JEBI', 'Swallow', 'RO Korea'),
  createData(26, 1, 'KRATHON', 'KRATHON', 'A kind of fruit; santol', 'Thailand'),
  createData(27, 1, 'BARIJAT', 'BARIJAT', 'Marshallese for coastal areas impacted by waves/winds', 'U.S.A.'),
  createData(28, 2, 'TRAMI', 'TRAMI', 'A kind of flower belonging to the Rose family', 'Viet Nam'),
  createData(29, 2, 'KONG-REY', 'KONG-REY', 'Pretty girl in Khmer legend/the name of mountain', 'Cambodia'),
  createData(30, 2, 'YINXING', 'YINXING', 'A kind of local tree in China', 'China'),
  createData(31, 2, 'TORAJI', 'TORAJI', 'Beautiful flower found in Korea, its roots are used for food and medicine.', 'DPR Korea'),
  createData(32, 2, 'MAN-YI', 'MAN-YI', 'Name of a strait, now being a reservoir', 'Hong Kong, China'),
  createData(33, 2, 'USAGI', 'USAGI', 'Rabbit', 'Japan'),
  createData(34, 2, 'PABUK', 'PABUK', 'Big freshwater fish in the Mekong River', 'Lao PDR'),
  createData(35, 2, 'WUTIP', 'WUTIP', 'Butterfly', 'Macao, China'),
  createData(36, 2, 'SEPAT', 'SEPAT', 'A freshwater fish with small climbing perch', 'Malaysia'),
  createData(37, 2, 'MUN', 'MUN', 'Yapese for month of June', 'Micronesia'),
  createData(38, 2, 'DANAS', 'DANAS', 'To experience, to feel', 'Philippines'),
  createData(39, 2, 'NARI', 'NARI', 'Lily', 'RO Korea'),
  createData(40, 2, 'WIPHA', 'WIPHA', 'Name of woman', 'Thailand'),
  createData(41, 2, 'FRANCISCO', 'FRANCISCO', "Chamorro man's name", 'U.S.A.'),
  createData(42, 2, 'CO-MAY', 'CO-MAY', 'A kind of grass (Chrysopogon aciculatus)', 'Viet Nam'),
  createData(43, 2, 'KROSA', 'KROSA', 'Crane', 'Cambodia'),
  createData(44, 2, 'BAILU', 'BAILU', 'A white deer', 'China'),
  createData(45, 2, 'PODUL', 'PODUL', 'Willow tree', 'DPR Korea'),
  createData(46, 2, 'LINGLING', 'LINGLING', 'Name of young girls', 'Hong Kong, China'),
  createData(47, 2, 'KAJIKI', 'KAJIKI', 'Name of marine fish with beautiful colors (Dorado; spearfish)', 'Japan'),
  createData(48, 2, 'NONGFA', 'NONGFA', 'Name of lake in Lao PDR', 'Lao PDR'),
  createData(49, 2, 'PEIPAH', 'PEIPAH', 'A popular pet fish in Macao', 'Macao, China'),
  createData(50, 2, 'TAPAH', 'TAPAH', 'A freshwater fish ', 'Malaysia'),
  createData(51, 2, 'MITAG', 'MITAG', "Yap woman's name, meaning 'My eyes'", 'Micronesia'),
  createData(52, 2, 'RAGASA', 'RAGASA', 'Sudden quickening of movement', 'Philippines'),
  createData(53, 2, 'NEOGURI', 'NEOGURI', 'Raccoon dog', 'RO Korea'),
  createData(54, 2, 'BUALOI', 'BUALOI', 'A kind of Thai dessert', 'Thailand'),
  createData(55, 2, 'MATMO', 'MATMO', 'Heavy rain', 'U.S.A.'),
  createData(56, 2, 'HALONG', 'HALONG', 'A beautiful bay in Vietnam', 'Viet Nam'),
  createData(57, 3, 'NAKRI', 'NAKRI', 'A kind of flower', 'Cambodia'),
  createData(58, 3, 'FENGSHEN', 'FENGSHEN', 'God of wind', 'China'),
  createData(59, 3, 'KALMAEGI', 'KALMAEGI', 'Seagull', 'DPR Korea'),
  createData(60, 3, 'FUNG-WONG', 'FUNG-WONG', 'Phoenix (name of a peak)', 'Hong Kong, China'),
  createData(61, 3, 'KOTO', 'KOTO', 'Lyra; harp', 'Japan'),
  createData(62, 3, 'NOKAEN', 'NOKAEN', 'Name of bird; swallow', 'Lao PDR'),
  createData(63, 3, 'VONGFONG', 'VONGFONG', 'Wasp', 'Macao, China'),
  createData(64, 3, 'NURI', 'NURI', 'Blue crowned perroquet in the Malay language', 'Malaysia'),
  createData(65, 3, 'SINLAKU', 'SINLAKU', 'Kosrae legendary goddess', 'Micronesia'),
  createData(66, 3, 'HAGUPIT', 'HAGUPIT', 'Lash; flog', 'Philippines'),
  createData(67, 3, 'JANGMI', 'JANGMI', 'Rose', 'RO Korea'),
  createData(68, 3, 'MEKKHALA', 'MEKKHALA', 'Angel of Ocean in Thai fairy tale', 'Thailand'),
  createData(69, 3, 'HIGOS', 'HIGOS', 'Chamorro word for "fig"', 'U.S.A.'),
  createData(70, 3, 'BAVI', 'BAVI', 'A mountain range in northern Viet Nam', 'Viet Nam'),
  createData(71, 3, 'MAYSAK', 'MAYSAK', 'A kind of tree', 'Cambodia'),
  createData(72, 3, 'HAISHEN', 'HAISHEN', 'God of sea', 'China'),
  createData(73, 3, 'NOUL', 'NOUL', 'Glows, red sky', 'DPR Korea'),
  createData(74, 3, 'DOLPHIN', 'DOLPHIN', 'A Chinese white dolphin which lives in Hong Kong waters, and is also a mascot of Hong Kong.', 'Hong Kong, China'),
  createData(75, 3, 'KUJIRA', 'KUJIRA', 'Cetus, whale', 'Japan'),
  createData(76, 3, 'CHAN-HOM', 'CHAN-HOM', 'A kind of tree', 'Lao PDR'),
  createData(77, 3, 'LINFA', 'LINFA', 'Lotus', 'Macao, China'),
  createData(78, 3, 'NANGKA', 'NANGKA', 'Jackfruit', 'Malaysia'),
  createData(79, 3, 'SAUDEL', 'SAUDEL', "Chief Soudelor's trusted guard/soldier", 'Micronesia'),
  createData(80, 3, 'MOLAVE', 'MOLAVE', 'A hardwood used in furniture', 'Philippines'),
  createData(81, 3, 'GONI', 'GONI', 'Swan', 'RO Korea'),
  createData(82, 3, 'ATSANI', 'ATSANI', 'Lightning streak', 'Thailand'),
  createData(83, 3, 'ETAU', 'ETAU', 'Palauan word for "storm cloud"', 'U.S.A.'),
  createData(84, 3, 'VAMCO', 'VAMCO', 'A river in southern Viet Nam', 'Viet Nam'),
  createData(85, 4, 'KROVANH', 'KROVANH', 'A kind of tree (Amomum krervanh Pierre)', 'Cambodia'),
  createData(86, 4, 'DUJUAN', 'DUJUAN', 'Azalea', 'China'),
  createData(87, 4, 'SURIGAE', 'SURIGAE', 'A kind of eagle', 'DPR Korea'),
  createData(88, 4, 'CHOI-WAN', 'CHOI-WAN', 'Colorful cloud', 'Hong Kong, China'),
  createData(89, 4, 'KOGUMA', 'KOGUMA', 'Ursa Minor; little bear', 'Japan'),
  createData(90, 4, 'CHAMPI', 'CHAMPI', 'A kind of flower (White Champaka)', 'Lao PDR'),
  createData(91, 4, 'IN-FA', 'IN-FA', 'Fireworks', 'Macao, China'),
  createData(92, 4, 'CEMPAKA', 'CEMPAKA', 'A kind of flower (Champak)', 'Malaysia'),
  createData(93, 4, 'NEPARTAK', 'NEPARTAK', 'Famous Kosrae warrior', 'Micronesia'),
  createData(94, 4, 'LUPIT', 'LUPIT', 'Cruel, viciousness', 'Philippines'),
  createData(95, 4, 'MIRINAE', 'MIRINAE', 'Milky way', 'RO Korea'),
  createData(96, 4, 'NIDA', 'NIDA', 'Name of woman', 'Thailand'),
  createData(97, 4, 'OMAIS', 'OMAIS', 'Palauan word for "wandering around"', 'U.S.A.'),
  createData(98, 4, 'CONSON', 'CONSON', 'A historical place in Viet Nam', 'Viet Nam'),
  createData(99, 4, 'CHANTHU', 'CHANTHU', 'A kind of flower', 'Cambodia'),
  createData(100, 4, 'DIANMU', 'DIANMU', 'Mother of lightning', 'China'),
  createData(101, 4, 'MINDULLE', 'MINDULLE', 'A kind of flower (Dandelion)', 'DPR Korea'),
  createData(102, 4, 'LIONROCK', 'LIONROCK', 'Name of a peak in Hong Kong', 'Hong Kong, China'),
  createData(103, 4, 'KOMPASU', 'KOMPASU', 'Circinus', 'Japan'),
  createData(104, 4, 'NAMTHEUN', 'NAMTHEUN', 'River, which is one of the tributaries of the Mekong River', 'Lao PDR'),
  createData(105, 4, 'MALOU', 'MALOU', 'Agate (It is a very hard stone with bands of color and often used for ornaments.)', 'Macao, China'),
  createData(106, 4, 'NYATOH', 'NYATOH', 'A kind of hardwood tree', 'Malaysia'),
  createData(107, 4, 'RAI', 'RAI', 'Stone money of Yap', 'Micronesia'),
  createData(108, 4, 'MALAKAS', 'MALAKAS', 'Strong; powerful', 'Philippines'),
  createData(109, 4, 'MEGI', 'MEGI', 'A kind of fish (Catfish)', 'RO Korea'),
  createData(110, 4, 'CHABA', 'CHABA', 'A kind of flower (the shoe flower, hibiscus)', 'Thailand'),
  createData(111, 4, 'AERE', 'แอAEREรี', 'Marshallese for a storm', 'U.S.A.'),
  createData(112, 4, 'SONGDA', 'SONGDA', 'A river in northwestern Viet Nam', 'Viet Nam'),
  createData(113, 5, 'TRASES', 'TRASES', 'Woodpecker', 'Cambodia'),
  createData(114, 5, 'MULAN', 'MULAN', 'A kind of flower (Magnolia)', 'China'),
  createData(115, 5, 'MEARI', 'MEARI', 'Reflection of sound or echo', 'DPR Korea'),
  createData(116, 5, 'MA-ON', 'MA-ON', 'Name of a peak, meaning a saddle.', 'Hong Kong, China'),
  createData(117, 5, 'TOKAGE', 'TOKAGE', 'Lacerta; lizard', 'Japan'),
  createData(118, 5, 'HINNAMNOR', 'HINNAMNOR', 'Name of the National Protected Area in Lao PDR', 'Lao PDR'),
  createData(119, 5, 'MUIFA', 'MUIFA', 'Plum blossom', 'Macao, China'),
  createData(120, 5, 'MERBOK', 'MERBOK', 'Name of bird; swallow', 'Malaysia'),
  createData(121, 5, 'NANMADOL', 'NANMADOL', 'A famous Pohnpei ruin; the "Venice of the Pacific"', 'Micronesia'),
  createData(122, 5, 'TALAS', 'TALAS', 'Sharpness; acuteness', 'Philippines'),
  createData(123, 5, 'NORU', 'NORU', 'A kind of deer (Roe deer)', 'RO Korea'),
  createData(124, 5, 'KULAP', 'KULAP', 'A kind of flower belonging to the Rose family', 'Thailand'),
  createData(125, 5, 'ROKE', 'ROKE', "Chamorro man's name", 'U.S.A.'),
  createData(126, 5, 'SONCA', 'SONCA', 'A singing bird', 'Viet Nam'),
  createData(127, 5, 'NESAT', 'NESAT', 'Fishing', 'Cambodia'),
  createData(128, 5, 'HAITANG', 'HAITANG', 'Chinese flowering crabapple', 'China'),
  createData(129, 5, 'NALGAE', 'NALGAE', 'Wing', 'DPR Korea'),
  createData(130, 5, 'BANYAN', 'BANYAN', 'A kind of tree', 'Hong Kong, China'),
  createData(131, 5, 'YAMANEKO', 'YAMANEKO', 'Lynx; cat that lives in mountains and forests', 'Japan'),
  createData(132, 5, 'PAKHAR', 'PAKHAR', 'A freshwater fish, which lives in the lower Mekong River', 'Lao PDR'),
  createData(133, 5, 'SANVU', 'SANVU', 'Coral', 'Macao, China'),
  createData(134, 5, 'MAWAR', 'MAWAR', 'Rose', 'Malaysia'),
  createData(135, 5, 'GUCHOL', 'GUCHOL', 'Yapese word for "spice turmeric"', 'Micronesia'),
  createData(136, 5, 'TALIM', 'TALIM', 'Sharp or cutting edge', 'Philippines'),
  createData(137, 5, 'DOKSURI', 'DOKSURI', 'Eagle', 'RO Korea'),
  createData(138, 5, 'KHANUN', 'KHANUN', 'Thai fruit (Jackfruit)', 'Thailand'),
  createData(139, 5, 'LAN', 'LAN', 'Marshallese for a storm', 'U.S.A.'),
  createData(140, 5, 'SAOLA', 'SAOLA', 'An animal in the cattle family recently found in Viet Nam', 'Viet Nam'),
];

export default function AcccessibleTable() {
  const { t, i18n } = useTranslation();
  const classes = useStyles();

  const currentTH = i18n.language === 'th';
  const rowLang = currentTH ? rows : rowsEn;

  return (
    <TableContainer className={classes.container}>
      <Table stickyHeader aria-label="sticky table" id="storm-history-pacific">
        <TableHead>
          <TableRow>
            <TableCell align="center">{t('ลำดับที่')}</TableCell>
            <TableCell align="center">{t('ชุดที่')}</TableCell>
            <TableCell align="center">{t('ชื่อภาษาอังกฤษ')}</TableCell>
            <TableCell align="center">{t('ชื่อพายุ')}</TableCell>
            <TableCell align="center">{t('ความหมาย')}</TableCell>
            <TableCell align="center">{t('ประเทศที่มาของชื่อ')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rowLang.map((row) => (
            <TableRow key={row.no} style={{ backgroundColor: (row.set % 2 === 0) ? '#ecf0f1' : '#fff' }}>
              <TableCell component="th" scope="row" align="center">{row.no}</TableCell>
              <TableCell component="th" scope="row" align="center">{row.set}</TableCell>
              <TableCell component="th" scope="row" align="left">{row.nameEn}</TableCell>
              <TableCell component="th" scope="row" align="left">{row.nameTh}</TableCell>
              <TableCell component="th" scope="row" align="left">{row.meaning}</TableCell>
              <TableCell component="th" scope="row" align="left">{row.from}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
